// eslint-disable-next-line import/no-unresolved
import * as controllers from 'import-stimulus-controllers';
import application from './application';

// views/customer/components以下のjsをインポート
Object.keys(controllers).forEach((key) => {
  application.register(key.replace(/_component$/, '').replaceAll('_', '-'), controllers[key]);
});
